import { Directive, Input } from '@angular/core';
import { GridTileConfig } from '@models';

@Directive({
  selector: '[gridTileItem]'
})
export class GridTileItemDirective {
  @Input('gridTileItem') config: GridTileConfig = {};
  get colspan(): number {
    return this.config.colspan ?? 1;
  }
  get rowspan(): number {
    return this.config.rowspan ?? 1;
  }
}
